export type JobDetailRowType = 'ACCOUNTS' | 'EMAILS' | 'IMAGES' | 'INSERTS';

export interface JobDetailsRow {
  id: string;
  type: JobDetailRowType; // PAGES was replaced with 'Emails', according to Miro
  // Fields for 'Electronic' type
  total?: number;
  posted?: number;
  failed?: number;
  // Fields for 'Paper' type
  presort?: number;
  firstClass?: number;
  nonMail?: number;
  nonPrint?: number;
}

export const jobDetailsElecData: JobDetailsRow[] = [
  {
    id: 'job_detail_1',
    type: 'ACCOUNTS',
    total: 11,
    posted: 11,
    failed: 0,
  },
  {
    id: 'job_detail_2',
    type: 'EMAILS',
    total: 0,
    posted: 0,
    failed: 0,
  },
  {
    id: 'job_detail_3',
    type: 'IMAGES',
    total: 2092,
    posted: 1990,
    failed: 102,
  },
  {
    id: 'job_detail_4',
    type: 'INSERTS',
    total: 1,
    posted: 0,
    failed: 0,
  },
];

export const jobDetailsPaperData: JobDetailsRow[] = [
  {
    id: 'job_detail_1',
    type: 'ACCOUNTS',
    total: 10,
    presort: 5,
    firstClass: 5,
    nonMail: 0,
    nonPrint: 1,
  },
  {
    id: 'job_detail_2',
    type: 'EMAILS',
    total: 8,
    presort: 5,
    firstClass: 4,
    nonMail: 0,
    nonPrint: 0,
  },
  {
    id: 'job_detail_3',
    type: 'IMAGES',
    total: 2,
    presort: 1,
    firstClass: 1,
    nonMail: 0,
    nonPrint: 0,
  },
  {
    id: 'job_detail_4',
    type: 'INSERTS',
    total: 1,
    presort: 0,
    firstClass: 0,
    nonMail: 0,
    nonPrint: 0,
  },
];
